import React from 'react';
import HelpSvg from 'images/v5/icons/life-buoy-02.svg';
import ComponentsSvg from 'images/v5/icons/menu/components.svg';
// import DashboardSvg from 'images/v5/icons/menu/dashboard.svg';
import InboxSvg from 'images/v5/icons/menu/inbox.svg';
import ManufacturersSvg from 'images/v5/icons/menu/manufacturers.svg';
import NotificationsSvg from 'images/v5/icons/menu/notifications.svg';
import OrderOperatorsSvg from 'images/v5/icons/menu/order-operators.svg';
import OrdersSvg from 'images/v5/icons/menu/orders.svg';
import ReleasesSvg from 'images/v5/icons/menu/rocket.svg';
import SpecificationsSvg from 'images/v5/icons/menu/specifications.svg';
import SuppliersSvg from 'images/v5/icons/menu/suppliers.svg';
import WarehouseReleasesSvg from 'images/v5/icons/menu/warehouse-releases.svg';
import SettingsSvg from 'images/v5/icons/settings-01.svg';
import UserSvg from 'images/v5/icons/user-02.svg';
const menubarContent = [
    {
        main: true,
        items: [
            // {
            //   icon: <DashboardSvg />,
            //   slug: '/dashboard',
            //   name: 'SIDEBAR_MENU_DASHBOARD',
            // },
            {
                icon: React.createElement(SpecificationsSvg, null),
                slug: '/specifications',
                name: 'SIDEBAR_MENU_SPECIFICATIONS',
            },
            {
                icon: React.createElement(OrdersSvg, null),
                slug: '/orders',
                name: 'SIDEBAR_MENU_ORDERS',
            },
            {
                icon: React.createElement(WarehouseReleasesSvg, null),
                slug: '/warehouse-releases',
                name: 'SIDEBAR_MENU_WAREHOUSE_RELEASES',
            },
            {
                icon: React.createElement(ComponentsSvg, null),
                slug: '/components',
                name: 'SIDEBAR_MENU_COMPONENTS',
            },
            {
                icon: React.createElement(SuppliersSvg, null),
                slug: '/suppliers',
                name: 'SIDEBAR_MENU_SUPPLIERS',
            },
            {
                icon: React.createElement(OrderOperatorsSvg, null),
                slug: '/order-operators',
                name: 'SIDEBAR_MENU_ORDER_OPERATORS',
            },
            {
                icon: React.createElement(ManufacturersSvg, null),
                slug: '/manufacturers',
                name: 'SIDEBAR_MENU_MANUFACTURERS',
            },
        ],
    },
    {
        footer: true,
        items: [
            {
                icon: React.createElement(NotificationsSvg, null),
                slug: '/notifications',
                name: 'SIDEBAR_MENU_NOTIFICATIONS',
            },
            {
                icon: React.createElement(InboxSvg, null),
                slug: '/inbox',
                name: 'SIDEBAR_MENU_MESSAGES',
            },
            {
                icon: React.createElement(HelpSvg, null),
                slug: '/help',
                name: 'SIDEBAR_MENU_HELP',
            },
        ],
    },
    {
        hidden: true,
        items: [
            {
                icon: React.createElement(ReleasesSvg, null),
                slug: '/releases',
                name: 'SIDEBAR_MENU_CHANGELOG',
            },
            {
                icon: React.createElement(SettingsSvg, null),
                slug: '/specification-parameters',
                name: 'SIDEBAR_MENU_ADMINISTRATION',
            },
            {
                icon: React.createElement(UserSvg, null),
                slug: '/user-profile',
                name: 'SIDEBAR_MENU_PROFILE',
            },
        ],
    },
];
export default menubarContent;
